<template>
  <v-flex v-if="display === 'signup'" xs12 style="display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 0 5%; min-height: 800px; margin-bottom: 60px" class="pb-2">
    <v-flex style="flex: none">
      <v-flex xs12 style="font-size: 32px;margin-bottom: 20px; margin-top: 60px" class="primary--text">
        Create a Yakshof Market account
      </v-flex>
      <v-form style="display: flex; flex-direction: column; align-items: center">
        <v-text-field single-line solo flat ref="firstName" placeholder="First Name" v-model="firstName" :error-messages="firstNameErrorMsgs" required @blur="$v.firstName.$touch()" class="signupFormField mb-2" color="accent"></v-text-field>
        <v-text-field single-line solo flat ref="lastName" placeholder="Last Name" v-model="lastName" :error-messages="lastNameErrorMsgs" required @blur="$v.lastName.$touch()" class="signupFormField mb-2" color="accent"></v-text-field>
        <v-text-field :disabled="signupDisable" single-line solo flat ref="organization" placeholder="Organization" v-model="organization" :error-messages="organizationErrorMsgs" required @blur="$v.organization.$touch()" class="signupFormField mb-2" color="accent"></v-text-field>
        <v-text-field :disabled="signupDisable" single-line solo flat ref="signupEmail" placeholder="Email" v-model="signupEmail" :error-messages="signupEmailErrorMsgs" required @blur="$v.signupEmail.$touch()" class="signupFormField mb-2" color="accent"></v-text-field>
        <v-text-field type="password" single-line solo flat ref="signupPassword" placeholder="Password" v-model="signupPassword" :error-messages="signupPasswordErrorMsgs" required @blur="$v.signupPassword.$touch()" class="signupFormField mb-2" color="accent"></v-text-field>
        <v-text-field type="password" single-line solo flat ref="passwordConfirmation" placeholder="Confirm Password" v-model="passwordConfirmation" :error-messages="passwordConfirmationErrorMsgs" required @blur="$v.passwordConfirmation.$touch()" class="signupFormField mb-2" color="accent"></v-text-field>
        <Card class='stripe-card stripeCard'
          :stripe='stripeKey'
          :options='stripeOptions'
          v-if="!signupDisable"
          @change='complete = $event.complete'
        ></Card>
        <v-btn :disabled="signupBtnDisabled" large round @click="submitSignupForm()" class="primary secondary--text submitSignupBtn mt-4" style="height: 50px;" :loading="signupLoadingState === 'loading'">Signup<v-icon>keyboard_arrow_right</v-icon></v-btn>
      </v-form>
      <v-flex xs12 my-3 style="text-align: center; font-size: 18px">
        Already have an account? Login <span class="loginBtn" @click="$router.push({path: '/login', query: $route.query})" small flat :ripple="false" style="padding-left: 0; min-width: 30px; margin-left: 0; font-weight: 700; cursor: pointer">HERE</span>.
      </v-flex>
    </v-flex>
  </v-flex>
  <v-flex v-else-if="display === 'signedup'" xs12 style="height: 600px; display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 60px 5%">
    <div style="text-align: left">
      <img src="@/assets/check.png" style="margin-bottom: 20px; max-height: 190px; margin: 0; padding: 0">
      <v-flex xs12 style="font-size: 36px; font-weight: 700" class="primary--text">You have been successfully signed up!</v-flex>
      <v-flex xs12 style="font-size: 18px;" class="primary--text">An email message has been sent to your address.</v-flex>
      <v-flex xs12 style="font-size: 18px;" class="primary--text">Kindly follow its instructions to activate your account.</v-flex>
      <v-btn flat round class="mt-5 primary doneBtn" :ripple="false" @click="$router.push({path: '/login'})">Done</v-btn>
    </div>
  </v-flex>
</template>

<style>
  .loginBtn .v-btn__content{
    font-weight: 800;
    font-size: 18px;
  }
  .doneBtn{
    width: 160px;
    margin-left: 0;
    height: 45px;
  }
  .doneBtn:hover:before{
    background-color: transparent;
  }
  .signupFormField, .stripeCard{
    border-radius: 50px;
    max-width: 450px;
    width: 80%;
    border: 1px solid #011E41 !important;
  }
  .stripeCard {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .stripeCard .StripeElement{
    width: 100%;
    padding: 0 20px !important;
    background-color: transparent !important;
    box-shadow: none !important;
    display: flex !important;
    align-items: center !important;
  }
  .stripeCard .__PrivateStripeElement{
    width: 100% !important;
  }
  .signupFormField .v-input__slot{
    background: transparent !important;
    border-radius: 50% !important;
    padding-top: 0px !important;
    margin-bottom: 0 !important;
    padding-left: 20px !important;
  }
  .signupFormField{
    max-height: 50px;
  }
  .signupFormField.theme--light.v-input--is-disabled input{
    color: #011E41;
  }
  .signupFormField .v-text-field__details{
    position: absolute;
    bottom: 0;
    margin-bottom: 0 !important;
    padding-left: 20px !important;
  }
  .singupFormField .v-text-field__details{
    padding-left: 22px !important;
  }
  .submitSignupBtn .v-btn__content{
    font-size: 18px;
    font-weight: 300;
  }
  .submitSignupBtn.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat){
    background-color: #B2BBC5 !important;
    color: white !important;
  }
</style>

<script>
import vh, { firstName, lastName, passwordConfirmation, organization, email, signupPassword } from '@/helpers/validators'
import { mapMutations, mapGetters } from 'vuex'
import axios from 'axios'
import { Card, createToken } from 'vue-stripe-elements-plus'
import config from '@/helpers/config'

export default {
  data () {
    return {
      display: 'signup',
      signupEmail: '',
      complete: false,
      signupPassword: '',
      passwordConfirmation: '',
      firstName: '',
      lastName: '',
      organization: '',
      signupLoadingState: 'none',
      generatedUuid: null,
      signupDisable: false,
      user: null,
      stripeKey: config.stripeKey,
      stripeOptions: { style: { base: { color: '#32325d', lineHeight: '18px', fontFamily: '"Helvetica Neue", Helvetica, sans-serif', fontSmoothing: 'antialiased', fontSize: '16px', '::placeholder': { color: '#aab7c4' } }, invalid: { color: '#fa755a', iconColor: '#fa755a' } }, hidePostalCode: true }
    }
  },
  validations: {
    signupEmail: vh.vrules(email),
    signupPassword: vh.vrules(signupPassword),
    firstName: vh.vrules(firstName),
    passwordConfirmation: vh.vrules(passwordConfirmation, signupPassword),
    lastName: vh.vrules(lastName),
    organization: vh.vrules(organization)
  },
  components: {
    Card
  },
  computed: {
    ...mapGetters({getRoleByName: 'getRoleByName', getNewUserUuid: 'getNewUserUuid', getPlanByUuid: 'getPlanByUuid'}),
    signupBtnDisabled () {
      return this.$v.signupEmail.$invalid || this.$v.signupPassword.$invalid || this.$v.firstName.$invalid || this.$v.passwordConfirmation.$invalid || this.$v.lastName.$invalid || this.$v.organization.$invalid || (!this.complete && !this.signupDisable)
    },
    signupEmailErrorMsgs () {
      if (this.$v.signupEmail.$dirty) {
        return vh.vmsg(this.$v.signupEmail, email)
      } else {
        return []
      }
    },
    signupPasswordErrorMsgs () {
      if (this.$v.signupPassword.$dirty) {
        return vh.vmsg(this.$v.signupPassword, signupPassword)
      } else {
        return []
      }
    },
    passwordConfirmationErrorMsgs () {
      if (this.$v.passwordConfirmation.$dirty) {
        return vh.vmsg(this.$v.passwordConfirmation, passwordConfirmation)
      } else {
        return []
      }
    },
    firstNameErrorMsgs () {
      if (this.$v.firstName.$dirty) {
        return vh.vmsg(this.$v.firstName, firstName)
      } else {
        return []
      }
    },
    lastNameErrorMsgs () {
      if (this.$v.lastName.$dirty) {
        return vh.vmsg(this.$v.lastName, lastName)
      } else {
        return []
      }
    },
    organizationErrorMsgs () {
      if (this.$v.organization.$dirty) {
        return vh.vmsg(this.$v.organization, organization)
      } else {
        return []
      }
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    submitSignupForm () {
      this.$v.$touch()
      if (this.$v.signupEmail.$invalid || this.$v.signupPassword.$invalid || this.$v.firstName.$invalid || this.$v.passwordConfirmation.$invalid || this.$v.lastName.$invalid || this.$v.organization.$invalid) {
        return
      }
      this.signupLoadingState = 'loading'
      if (!this.signupDisable) {
        this.generateUuid()
      } else {
        this.signup()
      }
    },
    generateUuid () {
      axios.all([this.$store.dispatch('stripe/generateUuid')]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.generatedUuid = response.data.payload
          createToken().then(data => this.addCard(data.token.id))
        } else {
          this.signupLoadingState = 'none'
          this.notify({message: 'Something went wrong, please try again later.', show: true})
        }
      })).catch((err) => {
        this.signupLoadingState = 'none'
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    async addCard (source) {
      try {
        let organizationUuid = this.generatedUuid
        let email = this.signupEmail
        let description = 'description'
        let customerResponse = await this.$store.dispatch('stripe/addCard', {organizationUuid: organizationUuid, email: email, source: source, description: description})
        if (customerResponse.data.status === 'SUCCESS') {
          if (customerResponse.data.payload !== undefined && customerResponse.data.payload.sources !== null) {
            this.signup(customerResponse.data.payload)
            console.log(customerResponse.data.payload)
          } else {
            this.notify({message: 'Something went wrong, please try again later.', show: true})
            this.signupLoadingState = 'none'
          }
        } else {
          this.notify({message: 'Something went wrong, please try again later.', show: true})
          this.signupLoadingState = 'none'
        }
      } catch (err) {
        this.signupLoadingState = 'none'
        this.notify({message: 'Something went wrong, please try again later.', show: true})
        console.log(err)
      }
    },
    async signup (organization) {
      try {
        if (this.signupDisable) {
          this.user.firstName = this.firstName
          this.user.lastName = this.lastName
          this.user.password = this.signupPassword
          await this.$store.dispatch('updateUser', {...this.user})
          this.$data.display = 'signedup'
          this.signupLoadingState = 'none'
        } else {
          axios.all([this.$store.dispatch('getUserByEmail', {email: this.signupEmail.toLowerCase()})]).then(axios.spread((userResponse) => {
            if (userResponse.data.status === 'SUCCESS') {
              this.signupEmail = ''
              this.$v.signupEmail.$touch()
              this.notify({message: 'This email is already being used.', show: true})
              this.signupLoadingState = 'none'
            } else {
              this.signupLoadingState = 'none'
              this.notify({message: 'Something went wrong.', show: true})
            }
          })).catch((err) => {
            if (err.response.status === 400) {
              axios.all([this.$store.dispatch('getOrganizationByName', {organizationName: this.organization})]).then(axios.spread((response) => {
                if (response.data.status === 'SUCCESS') {
                  this.organization = ''
                  this.$v.organization.$touch()
                  this.notify({message: 'This organization has already been registered.', show: true})
                } else {
                  this.notify({message: 'Something went wrong.', show: true})
                }
                this.signupLoadingState = 'none'
              })).catch((err) => {
                if (err.response.status === 400) {
                  var user = { email: this.$data.signupEmail.toLowerCase(), password: this.$data.signupPassword, firstName: this.$data.firstName, lastName: this.$data.lastName, defaultRoleId: this.signupDisabled ? this.getRoleByName('VIEWER_ROLE').id : this.getRoleByName('ADMIN_ROLE').id, organizations: [{ name: this.$data.organization, uuid: this.generatedUuid, active: true }] }
                  axios.all([this.$store.dispatch('addUser', user)]).then(axios.spread((response) => {
                    if (response.data.status === 'SUCCESS') {
                      this.$data.display = 'signedup'
                      this.signupLoadingState = 'none'
                    } else {
                      this.signupLoadingState = 'none'
                      this.notify({message: 'Something went wrong.', show: true})
                    }
                  })).catch((err) => {
                    this.signupLoadingState = 'none'
                    if (err.response.status === 400) {
                      this.notify({message: 'Please make sure your email is valid.', show: true})
                    } else {
                      this.notify({message: 'Something went wrong while connecting to the server.', show: true})
                    }
                    console.log(err)
                  })
                } else {
                  this.notify({message: 'Something went wrong while connecting to the server.', show: true})
                  console.log(err)
                  this.signupLoadingState = 'none'
                }
              })
            } else {
              this.signupLoadingState = 'none'
              this.notify({message: 'Something went wrong while connecting to the server.', show: true})
              console.log(err)
            }
          })
        }
      } catch (e) {
        this.notify({message: 'Something went wrong, please try again later.', show: true})
        this.signupLoadingState = 'none'
      }
    },
    getUserData () {
      axios.all([this.$store.dispatch('getUserByUuid', {uuid: this.$route.query.user})]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.user = response.data.payload
          this.signupDisable = true
          this.signupEmail = response.data.payload.email
          this.organization = response.data.payload.organizations.find(item => { return item.id === response.data.payload.defaultOrganizationId }).name
        } else {
          this.notify({message: 'Something went wrong.', show: true})
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    }
  },
  mounted () {
    if (this.$route.query && this.$route.query.user && this.$route.query.user !== '') {
      this.getUserData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Signup.vue